// extracted by mini-css-extract-plugin
module.exports = {"inputNumber":"index-module--input-number--2P85z"};